// extracted by mini-css-extract-plugin
export default {"wrapper":"Team_wrapper__-YiNq","inner":"Team_inner__yydPs"};